import { Component, Input } from '@angular/core';
import { DynamicModalRequestService } from 'src/app/shared/dynamic-modal/dynamic-modal-request.service';
import { TituloEleitor } from '../titulo-eleitor/model/titulo-eleitor';
import { DadosBasicosPfDTO } from './model/dados-basicos-pf-dto';

@Component({
  selector: 'via-dados-basicos-pf',
  templateUrl: './dados-basicos-pf.component.html',
  styleUrls: ['./dados-basicos-pf.component.css']
})
export class DadosBasicosPfComponent {
  @Input() public cpf: string;
  @Input() public dadosBasicos: DadosBasicosPfDTO;
  @Input() public tituloEleitor: TituloEleitor;
  @Input() public isCadeiaNi = false;

  constructor(
    private dynamicModalRequestService: DynamicModalRequestService,
  ) { }

  public exibeDadosTituloEleitor() {
    this.dynamicModalRequestService.exibirDadosTituloEleitor(this.cpf);
  }
}
